module.exports = __webpack_public_path__ + "static/media/Atlanta-01.64462132.jpg";